/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Actions"], function (require, exports, Actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ServicesActions = /** @class */ (function (_super) {
        __extends(ServicesActions, _super);
        function ServicesActions() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ServicesActions.getKey = function () {
            return "services-actions";
        };
        ServicesActions.prototype.initialize = function () {
            this._servicesFetched = new Actions_1.Action();
        };
        Object.defineProperty(ServicesActions.prototype, "servicesFetched", {
            get: function () {
                return this._servicesFetched;
            },
            enumerable: true,
            configurable: true
        });
        return ServicesActions;
    }(Actions_1.ActionsHubBase));
    exports.ServicesActions = ServicesActions;
});
